import { _x } from '@safe-wordpress/i18n';

export const devicesList = {
	desktop: _x( 'Desktop', 'text', 'nelio-ab-testing' ),
	mobile: _x( 'Mobile', 'text', 'nelio-ab-testing' ),
	tablet: _x( 'Tablet', 'text', 'nelio-ab-testing' ),
	smarttv: _x( 'Smart TV', 'text', 'nelio-ab-testing' ),
};
